import React, { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';

const ThemeToggle = () => {
 const [theme, setTheme] = useState(() => {
 // Get theme from localStorage or default to 'light'
 return localStorage.getItem('theme') || 'light';
 });

 useEffect(() => {
 // Apply theme to document root
 const root = document.documentElement;
 
 if (theme === 'dark') {
 root.classList.add('dark');
 } else {
 root.classList.remove('dark');
 }
 
 // Save to localStorage
 localStorage.setItem('theme', theme);
 }, [theme]);

 const toggleTheme = () => {
 setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
 };

 return (
 <Button
 variant="ghost"
 size="icon"
 onClick={toggleTheme}
 aria-label="Toggle theme"
 className="relative"
 >
 <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
 <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
 </Button>
 );
};

export default ThemeToggle;
